import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { serverBaseUrl } from '../../shared/helpers/functions';

const baseUrl = serverBaseUrl(environment.baseUrl);

@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {
  constructor(private cookieService: CookieService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authToken = this.cookieService.get('access_token');
    if (authToken && req.url.startsWith(baseUrl)) {
      const authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${authToken}`,
          'Accept-Language': 'en-US'
        }
      });
      return next.handle(authReq);
    }
    return next.handle(req);
  }
}
